import React, { useRef } from 'react'

import { Banner, Button, Page } from '@fielded/shared-ui'
import { Refresh } from '@fielded/shared-ui/src/icons'

import { getNavigationItem } from '../../../../../../common/utils/navigationInfo'
import TimeNavigator from '../../../../../../van-shared/components/TimeNavigator'

const LMDListError = ({ config, filters, history, onRetry }) => {
  const timeOptionsExpand = useRef()

  return (
    <Page className='shipments'>
      <Page.ComposableHeader>
        <Page.ComposableHeader.Breadcrumb
          items={[getNavigationItem({ item: 'shipments', config, includePath: false })]}
        />
        <Page.ComposableHeader.Content spread>
          <Page.ComposableHeader.Title title='Last mile deliveries' />
          <TimeNavigator
            className='vs-u-margin-bottom-double'
            filters={filters}
            history={history}
            programIds={[]}
            timeOptionsExpand={timeOptionsExpand}
            onTimeframeSelected={() => {}}
            centered={false}
            hasNoCycleOptions
          />
        </Page.ComposableHeader.Content>
      </Page.ComposableHeader>
      <Page.Panel>
        <Banner
          inline
          center
          type='warning'
          title='Dashboard failed to load'
        >
          <p>Shipment and route data couldn't be fetched. This is usually temporary.</p>
          <Button
            fill='full'
            colorVariant='brand'
            icon={<Refresh direction='right' />}
            iconSide='left'
            onClick={onRetry}
          >
            Retry
          </Button>
        </Banner>
      </Page.Panel>
    </Page>
  )
}

export default LMDListError
